import Api from '@/services/Api'


const HEADERURL = 'cat/lista-precio/';
const ACCION_AGREGAR_PRECIO = 'agregar_precio';
const ACCION_AGREGAR_PRODUCTO = 'agregar_producto';
const ACCION_AGREGAR_TIENDA = 'agregar_tienda';
const ACCION_ELIMINAR_PRODUCTO = 'eliminar_producto';
const ACCION_ELIMINAR_TIENDA = 'eliminar_tienda';


export default {
    
    fetch(params) {
        return Api().get(HEADERURL,{
            params: params
        })
    },
    getById(id) {
        return Api().get(HEADERURL + id)
    },
    save(params) {
        let url = HEADERURL;
        if ('pk' in params) {
            params.id = params.pk;
            return Api().put(url + params.id + '/', params)
        }
        return Api().post(url, params)
    },
    agregar_producto(id, params) {
        return Api().post(`${HEADERURL}${id}/${ACCION_AGREGAR_PRODUCTO}/`, params);
    },
    eliminar_producto(id, params) {
        return Api().post(`${HEADERURL}${id}/${ACCION_ELIMINAR_PRODUCTO}/`, params);
    },
    agregar_tienda(id, params) {
        return Api().post(`${HEADERURL}${id}/${ACCION_AGREGAR_TIENDA}/`, params);
    },
    eliminar_tienda(id, params) {
        return Api().post(`${HEADERURL}${id}/${ACCION_ELIMINAR_TIENDA}/`, params);
    },
    agregar_precio(id, params) {
        return Api().post(`${HEADERURL}${id}/${ACCION_AGREGAR_PRECIO}/`, params);
    },
}